import React from "react";

import moment from "moment";

import { CARBON_PROGRAM_DRAFT_KIND, CarbonProgramDraftAdminUser, CarbonProgramDraftStatus, CarbonProgramDraftSummary } from "models";

import { Tag, TagColour } from "components";

const STATUS_DISPLAY: Record<CarbonProgramDraftStatus, { text: string; colour: TagColour }> = {
  draft: { text: "Draft", colour: "grey" },
  submitted: { text: "Waiting for review", colour: "blue" },
  approved: { text: "Approved", colour: "green" },
  rejected: { text: "Changes requested", colour: "red" },
  implemented: { text: "Live", colour: "green-300" },
};

export const DraftStatusTag = ({ status }: { status: CarbonProgramDraftStatus }) => (
  <Tag colour={STATUS_DISPLAY[status].colour} text={STATUS_DISPLAY[status].text} />
);

export const draftProgramName = ({ config }: Pick<CarbonProgramDraftSummary, "config">) =>
  (config.internalName as string | undefined) || (config.programName as string | undefined) || "Untitled program";

export const draftKindLabel = ({ kind }: Pick<CarbonProgramDraftSummary, "kind">) =>
  kind === CARBON_PROGRAM_DRAFT_KIND.create ? "New program" : "Change to a live program";

export const adminUserName = (adminUser: CarbonProgramDraftAdminUser | null) =>
  adminUser ? `${adminUser.firstName} ${adminUser.lastName}`.trim() || adminUser.email : "Unknown";

export const formatDraftDate = (date: string | null) => (date ? moment(date).format("DD.MM.YYYY HH:mm") : "");
